import Modal from 'react-modal';
import React, { useState, useEffect } from 'react';
import axios from 'axios';
// import '../server';
import './Confirmation.css';
import { toast } from 'react-toastify';
import { TITLE_ID } from '../../Constants';
import { gaEvents } from '../../util/events';
import Logout from '../Logout/Logout';

function Confirmation(props) {
  // can look at the comments in ImportConfirmation
  const {
    isShowLogin,
    onCloseModal,
    nft,
    walletAddress,
    refresh,
  } = props;

  const [showModal, setShowModal] = useState(false);
  const [transferSuccess, setTransferSuccess] = useState(false);
  const [isTransferDisabled, setIsTransferDisabled] = useState(false);

  const [showLogout, setShowLogout] = useState(false);
  const [errorText, setErrorText] = useState(null);

  useEffect(() => {
    if (isShowLogin) {
      setShowModal(true);
    }
  });

  function handleCloseModal() {
    setShowModal(false);
    onCloseModal();
    setIsTransferDisabled(false);
    setTransferSuccess(false);
  }

  function onShowLogout(errorText) {
    setErrorText(errorText);
    setShowLogout(true);
  }

  function transferNft() {
    setIsTransferDisabled(true);
    axios
      .post(
        `https://${TITLE_ID}.playfabapi.com/CloudScript/ExecuteFunction`,
        {
          FunctionName: 'TransferNftFromInventory',
          FunctionParameter: {
            ItemInstanceId: nft.instanceId, // nft.instanceId
            DestinationWalletAddress: walletAddress,
          },
        },
        {
          headers: {
            'X-EntityToken': window.sessionStorage.getItem('entity_token'),
          },
        },
      ).then((response) => {
        if (response.data.data.FunctionResult.message !== 'Success') {
          let errorMsg = 'Error transferring, please try again';
          //EntityProfileConstraintValidationFailed = 1398
          if (response.data.data.FunctionResult.code === 1398) {
            errorMsg = response.data.data.FunctionResult.message;
            onShowLogout(response.data.data.FunctionResult.message);
          }
          handleCloseModal();
          toast.error(
            errorMsg,
            {
              position: toast.POSITION.BOTTOM_RIGHT,
            },
          );
          gaEvents.transferError();
        } else {
          setTransferSuccess(true);
          gaEvents.transferSuccess();
          refresh();
        }
      });
  }

  return (
    <>
      {!transferSuccess
		&& (
    <Modal
      ariaHideApp={false}
      isOpen={showModal}
      onRequestClose={handleCloseModal}
      contentLabel="Minimal Modal Example"
      className="confirmation-modal "
      overlayClassName="myoverlay"
      closeTimeoutMS={500}
    >
    <Logout
      isOpen={showLogout}
      logoutErrorText={errorText}
      />
  <div className="login-form">
    <div className="confirmation-form">
      {/* <h1>LOGIN</h1> */}
      <h1 className="transfer-header">Are You Sure?</h1>
      <h2 className="nft-name-confirmation">{nft.data ? nft.data.Title : ''}</h2>
      <img className="test-img" src={nft.data ? nft.data.ImageUrl : ''} />
      <h2 className="transfer-text">
        Your gear will no longer be able to be used in-game if you
        transfer. Make sure the following information is correct.
        <br />
        {' '}
        <br />
        Transferring to your wallet address:
        {' '}
        {walletAddress}
      </h2>

      {!isTransferDisabled
      && (
      <button
        className="button transfer-button"
        onClick={transferNft}
      >
        Transfer
      </button>
      )}
      {isTransferDisabled
      && (
      <button
        className="button transfer-button disabled"
      >
        Transferring
      </button>
      )}

      <button
        className="button"
        onClick={handleCloseModal}
      >
        Close
      </button>
    </div>
  </div>
</Modal>
		)}
      {transferSuccess
    	&& (
    <Modal
      ariaHideApp={false}
      isOpen={showModal}
      onRequestClose={handleCloseModal}
      contentLabel="Minimal Modal Example"
      className="confirmation-modal "
      overlayClassName="myoverlay"
      closeTimeoutMS={500}
    >
      <div className="login-form">
        <div className="confirmation-form">
          <h2 className="nft-name-confirmation">{nft.data.Title ?? 'empty name'}</h2>
          <img className="test-img" src={nft.data ? nft.data.ImageUrl : ''} />
          <h1 className="transfer-header">Transferred</h1>
          <h2>You now have this gear in your wallet.</h2>

          <button
            className="button"
            onClick={handleCloseModal}
          >
            Close
          </button>
        </div>
      </div>
    </Modal>
    	)}
    </>
  );
}

export default Confirmation;
